<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalEntrustments",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					component: "html",
					props: {
						content:
							"<div class='fs4 fw7 lh125'>8. (III) What was the estimated value entrusted to dealers, customers, repairers, cutters and brokers during the past 12 months?</div>"
					},
					bindTo: ""
				},
				{
					label: "(a) Average Amount",
					component: "text",
					bindTo: "case.facts.entrustmentEstimatedAverageValue"
				},
				{
					label: "(b) Maximum Amount",
					component: "text",
					bindTo: "case.facts.entrustmentEstimatedMaxValue"
				},
				{
					label: "(c) At any one time",
					component: "text",
					bindTo: "case.facts.entrustmentEstimatedValueAtAnyOneTime"
				}
			]
		}
	}
}
</script>
